export default defineNuxtPlugin(async () => {
  const directoryStore = useDirectoryStore()

  // Загружаем регионы только если ещё не загружены
  if (!directoryStore.regions || directoryStore.regions.length === 0) {
    try {
      await directoryStore.fetchRegions()
    } catch (error) {
      console.warn('Не удалось загрузить регионы при инициализации:', error)
    }
  }
})
